import React, { useState, useEffect } from "react";
import "./einkaufsliste.css";

const LOCAL_STORAGE_KEY = "react-shopping-list-items";

const ShoppingList = () => {
  const [items, setItems] = useState(() => {
    const savedItems = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedItems ? JSON.parse(savedItems) : [];
  });

  const [newItemText, setNewItemText] = useState("");

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = () => {
    if (newItemText.trim() !== "") {
      const newItem = {
        id: Date.now(),
        text: newItemText.trim(),
        isBought: false,
      };

      setItems([...items, newItem]);
      setNewItemText("");
    }
  };

  const removeItem = (idToRemove) => {
    setItems(items.filter((item) => item.id !== idToRemove));
  };

  const toggleItemBought = (idToToggle) => {
    setItems(
      items.map((item) =>
        item.id === idToToggle ? { ...item, isBought: !item.isBought } : item
      )
    );
  };

  return (
    <div>
      <h1>Meine Persistente Einkaufsliste</h1>

      <input
        type="text"
        placeholder="Neuen Artikel hinzufügen..."
        value={newItemText}
        onChange={(e) => setNewItemText(e.target.value)}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            addItem();
          }
        }}
      />
      <button onClick={addItem}>Hinzufügen</button>

      <ul>
        {items.map((item) => (
          <li
            key={item.id}
            style={{
              textDecoration: item.isBought ? "line-through" : "none",
              cursor: "pointer",
            }}
            onClick={() => toggleItemBought(item.id)}
          >
            {item.text}
            <button
              onClick={(e) => {
                e.stopPropagation();
                removeItem(item.id);
              }}
              style={{ marginLeft: "10px", color: "red" }}
            >
              &times;
            </button>
          </li>
        ))}
      </ul>

      {items.length === 0 && <p>Die Liste ist leer! (Auch nach Refresh)</p>}
    </div>
  );
};

export default ShoppingList;
